module.exports = __webpack_public_path__ + "static/img/yytx37.63a21eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx37.png
// module id = 904
// module chunks = 0